<template>
    <div class="nevs-content">
        <div v-if="packagePopup.show" class="nevs-popup-container">
            <div class="nevs-popup">
                <div class="nevs-popup-text">
                    <NevsTextField v-model="packagePopup.data.name" :error="packagePopup.validation.name"
                                   :label="'*' + $LANG.Get('fields.nameHr') + ':'"></NevsTextField>
                    <NevsTextField v-model="packagePopup.data.name_en"
                                   :label="$LANG.Get('fields.nameEn') + ':'"></NevsTextField>
                    <NevsSelect :minimumSearchLength="3" v-model="packagePopup.data.code_kpd" :ajax="'select/product-codes'"
                                :label="$LANG.Get('fields.code_kpd') + ':'"></NevsSelect>
                    <NevsNumberField v-model="packagePopup.data.price" :error="packagePopup.validation.price"
                                     :label="'*' + $LANG.Get('fields.priceWithoutTax').split('%currency%').join($HELPERS.GetDefaultCurrency()) + ':'"
                                     class="package-popup-half"></NevsNumberField>
                    <NevsNumberField v-show="$store.state.user.client.tax_system" v-model="packagePopup.data.tax"
                                     :label="'*' + $LANG.Get('fields.tax') + ':'"
                                     class="package-popup-half"></NevsNumberField>
                    <NevsCheckbox v-model="packagePopup.data.active" :label="$LANG.Get('fields.activeM')"></NevsCheckbox>
                    <table class="package-products-table">
                        <thead>
                            <tr>
                                <th>{{ $LANG.Get('fields.product') }}</th>
                                <th style="width: 150px;">{{ $LANG.Get('fields.quantity') }}</th>
                                <th style="width: 20px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(packageProduct, key) in packagePopup.data.products" :key="key">
                                <td><NevsSelect v-model="packageProduct.product_id" :ajax="'select/products-no-wares'"></NevsSelect></td>
                                <td><NevsNumberField :decimal-places="2" v-model="packageProduct.quantity"></NevsNumberField></td>
                                <td><span :title="$LANG.Get('tooltips.delete')" class="package-button" @click="packagePopup.removeProduct(key)"><i
                                    class="fa-solid fa-trash"></i></span></td>
                            </tr>
                        </tbody>
                    </table>
                    <NevsButton style="margin-top: 10px;" @click="packagePopup.addProduct()"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.addProduct') }}</NevsButton>
                </div>
                <div class="nevs-popup-buttons">
                    <NevsButton class="error" @click="packagePopup.cancel()"><i class="fa-solid fa-xmark"></i> {{ $LANG.Get('buttons.cancel') }}</NevsButton>
                    <NevsButton class="success" @click="packagePopup.save()"><i class="fa-solid fa-check"></i> {{ $LANG.Get('buttons.ok') }}</NevsButton>
                </div>
            </div>
        </div>
        <NevsCard>
            <NevsTextField style="float: left;" :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="packagesData.filters.name"></NevsTextField>
            <NevsCheckbox style="float: left; margin-left: 15px;" :width="'auto'" :reserveHeights="true" v-model="packagesData.filters.show_inactive" :label="$LANG.Get('labels.showInactivePackages')"></NevsCheckbox>
            <span style="float: right;"><NevsButton class="primary" @click="addPackage"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.addPackage') }}</NevsButton></span>
            <div style="clear: both;"></div>

            <NevsTinyGrid :columns="gridColumns" :records="packagesData.records" :actions="gridActions"
                          :is-inactive="(packageItem) => !packageItem.active" @action="gridAction"></NevsTinyGrid>
        </NevsCard>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsTinyGrid from "@/components/nevs/NevsTinyGrid.vue";

export default {
    name: "ModulePackages",
    components: {NevsTinyGrid, NevsCheckbox, NevsSelect, NevsNumberField, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            packagesData: {
                filters: {
                    name: '',
                    show_inactive: false
                },
                records: [],
                filterTimer: null
            },
            packagePopup: {
                show: false,
                data: {
                    id: 0,
                    name: '',
                    name_en: '',
                    code_kpd: '',
                    price: 0,
                    tax: this.$store.state.settings.DEFAULT_TAX,
                    active: true,
                    products: []
                },
                validation: {
                    name: '',
                    price: ''
                },
                reset: () => {
                    this.packagePopup.data = {
                        id: 0,
                        name: '',
                        name_en: '',
                        code_kpd: '',
                        price: 0,
                        tax: this.$store.state.settings.DEFAULT_TAX,
                        active: true,
                        products: []
                    };
                    this.packagePopup.validation = {
                        name: '',
                        price: ''
                    };
                },
                cancel: () => {
                    this.packagePopup.show = false;
                },
                addProduct: () => {
                    this.packagePopup.data.products.push({
                        product_id: null,
                        quantity: 1
                    });
                },
                removeProduct: (index) => {
                    this.packagePopup.data.products.splice(index, 1);
                },
                save: () => {
                    let success = true;
                    if (this.packagePopup.data.name === '') {
                        success = false;
                        this.packagePopup.validation.name = this.$LANG.Get('labels.mandatoryField');
                    } else {
                        this.packagePopup.validation.name = '';
                    }
                    if (this.packagePopup.data.price < 0) {
                        success = false;
                        this.packagePopup.validation.price = this.$LANG.Get('labels.errorNegativeValue');
                    } else {
                        this.packagePopup.validation.price = '';
                    }
                    if (success) {
                        let payload = JSON.parse(JSON.stringify(this.packagePopup.data));
                        payload.products = payload.products.filter((product) => product.product_id !== null);
                        let method = (this.packagePopup.data.id === 0) ? 'post' : 'put';
                        let action = (this.packagePopup.data.id === 0) ? 'packages' : 'packages/' + this.packagePopup.data.id;
                        let vm = this;
                        this.$API.APICall(method, action, payload, (data, success) => {
                            vm.packagePopup.show = false;
                            vm.packagePopup.reset();
                            if (success) {
                                vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                                vm.reloadPackages();
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            }
        }
    },
    computed: {
        gridColumns() {
            return [
                {key: 'name', label: this.$LANG.Get('fields.name')},
                {
                    key: 'price_display',
                    label: this.$LANG.Get('fields.priceWithoutTax').split('%currency%').join(this.$HELPERS.GetDefaultCurrency()),
                    align: 'right'
                }
            ];
        },
        gridActions() {
            return [
                {name: 'edit', icon: 'fa-solid fa-pen', tooltip: this.$LANG.Get('tooltips.edit')},
                {name: 'delete', icon: 'fa-solid fa-trash', tooltip: this.$LANG.Get('tooltips.delete')}
            ];
        }
    },
    watch: {
        'packagesData.filters.name': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadPackages();
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        },
        'packagesData.filters.show_inactive': {
            handler() {
                this.reloadPackages();
            }
        }
    },
    methods: {
        gridAction(name, packageItem) {
            if (name === 'edit') {
                this.editPackage(packageItem);
            } else if (name === 'delete') {
                this.deletePackage(packageItem);
            }
        },
        editPackage(packageItem) {
            let vm = this;
            this.$API.APICall('get', 'packages/' + packageItem.id, {}, (data, success) => {
                if (success && data.package !== null) {
                    vm.packagePopup.reset();
                    vm.packagePopup.data = JSON.parse(JSON.stringify(data.package));
                    vm.packagePopup.show = true;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        addPackage() {
            this.packagePopup.reset();
            this.packagePopup.show = true;
        },
        deletePackage(packageItem) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        this.$API.APICall('delete', 'packages/' + packageItem.id, {}, (data, success) => {
                            if (success) {
                                vm.reloadPackages();
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        reloadPackages() {
            let vm = this;
            let request = {
                sort: {
                    field: 'name',
                    descending: false
                },
                filters: this.packagesData.filters,
                currentPage: 1,
                rowsPerPage: 0
            };
            this.$API.APICall('get', 'packages', request, (data, success) => {
                if (success) {
                    vm.packagesData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'catalog');
        this.$store.commit('selectSubMenu', 'packages');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.catalog'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.packages'),
                link: null
            }
        ]);
        this.reloadPackages();
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;
@use '../../scss/grids' as g;

/* Trash icon inside the package-products editor in the popup (the main grid uses NevsTinyGrid). */
.package-button {
    @include g.grid-action;
}

.package-popup-half {
    width: 50% !important;
}

.package-products-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.package-products-table th {
    text-align: left;
    font-size: 12px;
    padding: 0 5px;
}

.package-products-table td {
    padding: 0 5px;
    vertical-align: top;
}

@media only screen and (max-width: 1400px) {
    .package-popup-half {
        width: 100% !important;
    }
}
</style>
